import React, { useEffect, useState } from 'react';
import { Typography, Box } from "@curves/ui-base";
import { OrderAllowanceRecordTable } from '@icoach/accountBook/tables/';
import useOrderReturnApi from '@apis/useOrderReturnApi';

const AccountBookOrderAllowanceRecordPage = props => {
	const orderID = props.match.params.orderID;
	const { getOrderAbandonAllowanceApi } = useOrderReturnApi();
	const [sourceData, setSoueceData] = useState([]);

	const doOrderAbandonAllowanceApi = async orderID => {
		let res = await getOrderAbandonAllowanceApi(orderID);
		if (res) {
			setSoueceData(res);
		}
	};

	useEffect(
		() => {
			if (orderID) {
				doOrderAbandonAllowanceApi(orderID);
			}
		},
		// eslint-disable-next-line
		[orderID]
	);

	return (
		<Box className="container main-container-spacing">
			<Box component="header" className="page-header">
				<Typography className="page-header-title" variant="h3">
					訂單折讓歷史
				</Typography>
			</Box>
			<OrderAllowanceRecordTable rowsData={sourceData} refresh={() => doOrderAbandonAllowanceApi(orderID)} />
		</Box>
	);
};

export default AccountBookOrderAllowanceRecordPage;
